import { prefixObjectValues as pre } from '../utils';

const prefix = 'insurance-form';

const form = pre(
  {
    form: 'wrapper',
    activeToggle: 'active-toggle',
    coverageLimitsTextBox: 'cover-limit-textBox',
    effectiveDatePicker: 'effective-date-picker',
    expiryDatePicker: 'expiry-date-picker',
    insuranceCompanyInput: 'company-input',
    policyNumInput: 'poli-num-input',
    policyType: 'poli-type',
    producer: 'producer-input',
    cancelBtn: 'cancel-btn',
    submitBtn: 'submit-btn',
  },
  prefix
);

export default {
  ...form,
};
